import LocalEconomiesPanel from './LocalEconomiesPanel';

export default LocalEconomiesPanel;
